import React from 'react'
import ReservationTableContainer from '../../components/ReservationTable'
import { connect } from 'react-redux'
import { fetchReservations, clearReservation } from '../../actions/remote_api'
import { toastr } from 'react-redux-toastr'

class BookingSummaryTableContainer extends React.Component {
  isLoading = false

  fetchInstances = (params) => {
    toastr.info('Loading')
    this.isLoading = true
    this.props.fetchReservations({
      ...params,
      daily: true,
      createByKiosk: false,
      sort: 'serviceDateTime',
      order: 'desc',
      summaryReport: true,
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.isLoading &&
      prevProps.instances !== this.props.instances &&
      this.props.instances !== undefined
    ) {
      this.isLoading = false
      toastr.success('Load completed')
    }
  }

  clearInstances = () => {
    this.props.clearReservation('list')
  }

  render() {
    return (
      <ReservationTableContainer
        fetchInstances={this.fetchInstances}
        clearInstances={this.clearInstances}
        isCustomerSatisfactionShow={false}
        {...this.props}
      />
    )
  }
}

export default connect(
  ({ fetch }) => ({
    instances: fetch.reservation ? fetch.reservation.list : undefined,
    totalCount: fetch.reservation ? fetch.reservation.totalCount : undefined,
  }),
  { fetchReservations, clearReservation },
)(BookingSummaryTableContainer)
